import { Link } from '@remix-run/react';
import { FileQuestion } from 'lucide-react';
import { Button } from '~/components/ui/button';

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="flex flex-col items-center text-center">
        <div className="rounded-full bg-muted p-6">
          <FileQuestion className="h-12 w-12 text-muted-foreground" />
        </div>
        <h1 className="mt-6 text-3xl font-bold tracking-tight">Página não encontrada</h1>
        <p className="mt-2 max-w-sm text-muted-foreground">
          A página que você está procurando não existe ou foi removida.
        </p>
        <Button asChild className="mt-6">
          <Link to="/">Voltar ao Dashboard</Link>
        </Button>
      </div>
    </div>
  );
}
